import React, { Component } from "react";
import { connect } from "react-redux";
import {
    loginWithCredentials,
    logout,
    selectLoggedIn,
    selectLoggingIn,
    selectUsername,
    selectError,
} from "../../ducks/auth";

import Controls from "../../components/controls";
import Layout from "../../components/layout";

import Styles from "./login.module.scss";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: "",
            password: "",
        };
    }

    login = (e) => {
        e.preventDefault();
        const { username, password } = this.state;
        const { loginWithCredentials, history } = this.props;

        loginWithCredentials(username, password, true).then(ok => {
            if (ok) {
                history.push("/");
            }
        });
    };

    logout = () => {
        const { logout } = this.props;
        logout();
    }

    render() {
        return (
            <Layout.Page>
                <Layout.Card>
                    <Layout.CenterForm>
                        <h2>Login to Superloci</h2>
                        <Layout.Form onSubmit={this.login}>
                            <Layout.FormRow>
                                <Controls.Label>Username</Controls.Label>
                                <Controls.Input
                                    type="username"
                                    onChange={e =>
                                        this.setState({ username: e.target.value })
                                    }
                                />
                            </Layout.FormRow>
                            <Layout.FormRow>
                                <Controls.Label>Password</Controls.Label>
                                <Controls.Input
                                    type="password"
                                    onChange={e =>
                                        this.setState({ password: e.target.value })
                                    }
                                />
                            </Layout.FormRow>
                            <Layout.FormRow>
                                <Controls.Button type={"submit"}>Login</Controls.Button>
                            </Layout.FormRow>
                        </Layout.Form>
                    </Layout.CenterForm>
                </Layout.Card>
            </Layout.Page>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        loginSuccess: selectLoggedIn(state),
        loggingIn: selectLoggingIn(state),
        username: selectUsername(state),
        authError: selectError(state),
    };
};
const mapDispatchToProps = {
    loginWithCredentials,
    logout,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/pages/login/login.js